import { phraseInfo, tagInfo } from "./constants";

import TagLabel from "./TagLabel";
import PhraseParentheses from "./PhraseParentheses";

const GroupElement = ({
  element,
  lineHeight,
  selectedGroupIndex,
  handleClickGroup,
}) => {
  return (() => {
    const isSelected = selectedGroupIndex === element.groupIndex;
    const allTagInfo = { ...tagInfo, ...phraseInfo };

    return (
      <div
        style={{
          position: "relative",
          display: "flex",
        }}
      >
        <TagLabel element={element} isSelected={isSelected} />
        <div
          style={{
            display: "flex",
            marginTop: "20px",
            marginBottom: `calc(${lineHeight} - 20px)`,
            backgroundColor: isSelected
              ? "#EBEBEB"
              : element.groupType !== ""
              ? allTagInfo[element.groupType].backgroundColor
              : "#F6F8FA",
            border:
              element.groupType !== ""
                ? "1px solid " + allTagInfo[element.groupType].backgroundColor
                : "1px solid #EBEBEB",
            borderBottom:
              !isSelected &&
              element.groupType !== "" &&
              "1px solid " + allTagInfo[element.groupType].color,
            transition: "background-color 0.5s ease",
            cursor: "pointer",
          }}
          onClick={() => handleClickGroup()}
        >
          {element.text.map((text, index) => {
            if (!text) return null;
            return (
              <div
                style={{
                  display: "flex",
                  position: "relative",
                }}
              >
                {(text.phraseStart || []).map((phrase) => (
                  <PhraseParentheses
                    phrase={phrase}
                    isStart={true}
                    inGroup={true}
                  />
                ))}
                <span>{text.text}</span>

                {(text.phraseEnd || []).map((phrase) => (
                  <PhraseParentheses
                    phrase={phrase}
                    isStart={false}
                    inGroup={true}
                  />
                ))}
                <span>
                  {text.space_right > 0 &&
                    index < element.text.length - 1 &&
                    " "}
                </span>
              </div>
            );
          })}
        </div>
        <div>{element.text.at(-1)?.space_right > 0 && " "}</div>
      </div>
    );
  })();
};

export default GroupElement;
